/**
 * Created by hp on 2017/5/25.
 */
const defaults = {
    checkInMessage: {},
    checkInHead: '',
    checkInObject: {},
    showCheckInDialog: false,
};

export default (state = defaults, action) => {
    switch(action.type){
        case 'SHOW_CHECK_IN_DIALOG':
            return {...state, showCheckInDialog: true};
        case 'HIDE_CHECK_IN_DIALOG':
            return {...state, showCheckInDialog: false};
        case 'SET_CHECK_IN_OBJECT':
            return {...state, checkInObject: action.preload};
        case 'SET_CHECK_IN_HEAD':
            return {...state, checkInHead: action.preload};
        case 'SET_CHECK_IN_MESSAGE':
            return {...state, checkInMessage: action.preload};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/checkin.js